<comp-dialog size="large" dialogCardStyles="height: 90dvh;">
  <ng-container comp-dialog-header-title>{{
    'requirementIntake.evidence.reuse.dialogTitle' | translate
  }}</ng-container>
  <ng-container comp-dialog-content>
    @if (step() === 'select-evidence') {
      <div class="grid">
        @for (filterType of evidenceFilterTypes; track filterType) {
          <div
            class="tab-cell"
            role="button"
            tabindex="0"
            [class.active]="evidenceFilterType() === filterType"
            [attr.aria-pressed]="evidenceFilterType() === filterType"
            (click)="setFilterType(filterType)"
            (keydown.enter)="setFilterType(filterType)"
            (keydown.space)="setFilterType(filterType)"
          >
            <h2 class="title">
              {{
                'requirementIntake.evidence.reuse.filterModes.' + filterType + '.title' | translate
              }}
            </h2>
            <p class="description">
              {{
                'requirementIntake.evidence.reuse.filterModes.' + filterType + '.description'
                  | translate
              }}
            </p>
          </div>
        }
        <div class="empty-cell"></div>
        <div class="results-cell">
          <form class="ul-form" [formRoot]="evidenceFilterForm" id="selectEvidenceForm">
            <div class="form-inputs">
              <mat-form-field
                class="ul-single-line-input"
                appearance="outline"
                id="searchText"
                [floatLabel]="'always'"
              >
                <input
                  type="text"
                  matInput
                  [formField]="evidenceFilterForm.searchText"
                  placeholder="{{
                    'requirementIntake.evidence.reuse.searchTextPlaceholder' | translate
                  }}"
                />
              </mat-form-field>
              <mat-form-field
                id="filterType"
                appearance="outline"
                class="ul-single-line-input outlined-form-element"
              >
                <mat-label translate="requirementIntake.evidence.reuse.filterTypeLabel"></mat-label>
                <mat-select panelWidth="auto" [formField]="evidenceFilterForm.fileAttachmentFilter">
                  @for (filterType of fileAttachmentFilterTypes; track filterType) {
                    <mat-option [value]="filterType">
                      {{ 'requirementIntake.evidence.reuse.filterTypes.' + filterType | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (evidenceFilterType() === 'OTHER_REVISION') {
                <mat-form-field
                  id="revMode"
                  appearance="outline"
                  class="ul-single-line-input outlined-form-element"
                >
                  <mat-label translate="requirementIntake.evidence.reuse.revModeLabel"></mat-label>
                  <mat-select
                    panelWidth="auto"
                    [formField]="evidenceFilterForm.productRevisionFilter"
                  >
                    @for (filterType of productRevisionFilterTypes; track filterType) {
                      <mat-option [value]="filterType">
                        {{ 'requirementIntake.evidence.reuse.revModes.' + filterType | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
            <comp-scrollable-card>
              <comp-evidence-results
                [evidences]="evidencesResource.value() || []"
                [selectedEvidence]="selectedEvidence()"
                [evidenceFilter]="evidenceFilterType()"
                [searchText]="debouncedSearchText.value()"
                (select)="onEvidenceSelected($event)"
              ></comp-evidence-results>
            </comp-scrollable-card>
          </form>
        </div>
      </div>
    } @else if (step() === 'select-files') {
      <form class="ul-form select-files-form" [formRoot]="selectFilesForm" id="selectFilesForm">
        @if (selectedEvidence(); as selectedEvidence) {
          <nav class="breadcrumb">
            <span class="nolink"
              >{{ selectedEvidence.productName }} ({{ selectedEvidence.revisionName }})</span
            >
            <span class="breadcrumb-separator">/</span>
            <span class="nolink">{{ selectedEvidence.requirementName }}</span>
            <span class="breadcrumb-separator">/</span>
            <span class="nolink">{{ selectedEvidence.name }}</span>
          </nav>
          <p>
            {{ 'requirementIntake.evidence.reuse.selectFilesTitle' | translate }}
          </p>

          <ul class="select-files-list">
            @for (fileAttachment of selectedEvidence.fileAttachments; track fileAttachment.id) {
              <li class="select-files-list-item">
                <mat-checkbox
                  [checked]="isFileAttachmentSelected(fileAttachment.id)"
                  (change)="updateFileAttachmentSelection(fileAttachment.id, $event)"
                >
                  <comp-file-type
                    [file]="{
                      ...fileAttachment,
                      confirmReuse: false,
                    }"
                  ></comp-file-type>
                  <span class="downloadable-file-name">
                    <button (click)="downloadService.downloadFileAttachment(fileAttachment)">
                      {{ fileAttachment.filename }}
                    </button>
                  </span>
                </mat-checkbox>
              </li>
            }
          </ul>
        }
      </form>
    }
  </ng-container>

  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      @if (step() === 'select-files') {
        <ng-container ngProjectAs="[left]">
          <button
            comp-button="secondary"
            type="submit"
            (click)="goBack()"
            [disabled]="!selectedEvidence()"
          >
            <i class="ul-button__icon-left ul-icon -small">navigate_before</i>
            <span>{{ 'general.back' | translate }}</span>
          </button>
        </ng-container>
      }
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" mat-dialog-close>
          {{ 'general.cancel' | translate }}
        </button>
        @if (selectedEvidenceFileAttachments().length > 1 && step() === 'select-evidence') {
          <button
            comp-button
            action="save"
            type="submit"
            (click)="nextPage()"
            [disabled]="fileAttachmentIdsToSubmit().length === 0"
          >
            <span>{{ 'general.next' | translate }}</span>
            <i class="ul-button__icon-right ul-icon -small">navigate_next</i>
          </button>
        } @else {
          <button
            comp-button
            action="save"
            type="submit"
            (click)="submit()"
            [disabled]="fileAttachmentIdsToSubmit().length === 0"
          >
            {{ 'general.save' | translate }}
          </button>
        }
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
